var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Container, FormGroup, Input, Form, Card, CardFooter, CardBody } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Signals from '../../../signals/Signals';
import { ApplicationContext } from '../../../ApplicationContext';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import FormField from '../../components/ui/FormField/FormField';
import { FormErrorContext } from '../../../FormErrorContext';
import AssignSchemaToAssetCommand from '../../../commands/services/AssignSchemaToAssetCommand';
import ServiceSchemaSearch from '../../components/ui/ServiceSchemaSearch/ServiceSchemaSearch';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import GetServiceSchemasCommand from '../../../commands/services/GetServiceSchemasCommand';
import SchemaTriggerIntervalValueType from '../../../data/SchemaTriggerIntervalValueType';
import DateInput from '../../components/ui/DateInput/DateInput';
/**
 *
 */
var AssignSchemaToAssetOverlay = /** @class */ (function (_super) {
    __extends(AssignSchemaToAssetOverlay, _super);
    /**
     *
     * @param props
     */
    function AssignSchemaToAssetOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            submitting: false,
            schemaModel: null
        };
        _this.onDateChange = _this.onDateChange.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onBlurFirstHours = _this.onBlurFirstHours.bind(_this);
        _this.onSelectSchema = _this.onSelectSchema.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssignSchemaToAssetOverlay.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     * @param nextProps
     * @param nextContext
     */
    AssignSchemaToAssetOverlay.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.initialize();
    };
    AssignSchemaToAssetOverlay.prototype.initialize = function () {
        var _a = this.context, session = _a.session, serviceSchemaCollection = _a.serviceSchemaCollection;
        var assetModel = this.props.assetModel;
        var user = session.user;
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.setState({ firstHours: Math.ceil(assetModel.cumulativeOperatingHoursDurationInHours), firstDate: tomorrow });
        var command = new GetServiceSchemasCommand();
        command.execute(user, serviceSchemaCollection);
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    AssignSchemaToAssetOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    AssignSchemaToAssetOverlay.prototype.render = function () {
        var _a = this.props, className = _a.className, intl = _a.intl, assetModel = _a.assetModel, serviceAssetSchemaCollection = _a.serviceAssetSchemaCollection;
        var serviceSchemaCollection = this.context.serviceSchemaCollection;
        var _b = this.state, errors = _b.errors, schemaModel = _b.schemaModel, firstDate = _b.firstDate, firstHours = _b.firstHours;
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return React.createElement(Container, { className: 'new-service-entry-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'service.schema.assign.overlay.title' }, assetModel) }),
                        React.createElement(CardBody, null,
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12 col-md-6" },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "description" },
                                                    React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.schema" })))),
                                        React.createElement("div", { className: "w-100 d-flex align-items-start" },
                                            React.createElement(ServiceSchemaSearch, { value: schemaModel, intervalOnly: true, disableIds: serviceAssetSchemaCollection.list.map(function (serviceAssetModel) {
                                                    return serviceAssetModel.schemaId;
                                                }), serviceSchemaCollection: serviceSchemaCollection, onChange: this.onSelectSchema })))),
                                schemaModel && schemaModel.triggerIntervalValueType === SchemaTriggerIntervalValueType.OPERATIONAL_HOURS ?
                                    React.createElement("div", { className: "col-12 col-md-6" },
                                        React.createElement(FormGroup, null,
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col" },
                                                    React.createElement("label", { htmlFor: "firstHours" },
                                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.firsthours" })))),
                                            React.createElement(FormField, null,
                                                React.createElement(Input, { id: "firstHours", type: "number", name: "firstHours", required: true, min: Math.ceil(assetModel.cumulativeOperatingHoursDurationInHours), value: firstHours, onBlur: this.onBlurFirstHours })))) : null,
                                schemaModel && SchemaTriggerIntervalValueType.isPeriodial(schemaModel.triggerIntervalValueType) ?
                                    React.createElement("div", { className: "col-12 col-md-6" },
                                        React.createElement(FormGroup, null,
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col" },
                                                    React.createElement("label", { htmlFor: "name" },
                                                        React.createElement(FormattedMessage, { id: "service.schema.assign.overlay.field.firstdate" })))),
                                            React.createElement(FormField, null,
                                                React.createElement("div", { className: "input-group" },
                                                    React.createElement(DateInput, { intl: intl, name: null, id: null, onBlur: this.onDateChange, onChange: this.onDateChange, value: firstDate, openToDate: firstDate }),
                                                    React.createElement("div", { className: "input-group-append" },
                                                        React.createElement("span", { className: "input-group-text" },
                                                            React.createElement("i", { className: "fe fe-calendar" }))))))) : null)),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param event
     */
    AssignSchemaToAssetOverlay.prototype.onInputChange = function (event) {
        var newState = {};
        switch (event.target.name) {
            case 'firstHours':
                newState[event.target.name] = event.target.value;
                break;
            default:
                newState[event.target.name] = event.target.value;
        }
        this.setState(newState);
    };
    /**
     *
     * @param event
     */
    AssignSchemaToAssetOverlay.prototype.onBlurFirstHours = function (event) {
        var assetModel = this.props.assetModel;
        var newState = {};
        switch (event.target.name) {
            case 'firstHours':
                newState[event.target.name] = Math.max(event.target.value, Math.ceil(assetModel.cumulativeOperatingHoursDurationInHours));
                break;
            default:
        }
        this.setState(newState);
    };
    /**
     *
     */
    AssignSchemaToAssetOverlay.prototype.onDateChange = function (e, date) {
        if (date && !isNaN(date.getTime())) {
            this.setState({ firstDate: date });
        }
    };
    /**
     *
     */
    AssignSchemaToAssetOverlay.prototype.onSelectSchema = function (schemaModel) {
        this.setState({ schemaModel: schemaModel });
    };
    /**
     *
     * @param event
     */
    AssignSchemaToAssetOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var _a = this.props, assetModel = _a.assetModel, serviceAssetSchemaCollection = _a.serviceAssetSchemaCollection, intl = _a.intl;
        var _b = this.state, firstHours = _b.firstHours, firstDate = _b.firstDate, schemaModel = _b.schemaModel;
        if (!schemaModel) {
            return;
        }
        var value = SchemaTriggerIntervalValueType.isPeriodial(schemaModel.triggerIntervalValueType) ?
            firstDate.getTime() :
            firstHours;
        var command = new AssignSchemaToAssetCommand();
        command.execute(value, session.user.organisation.id, schemaModel, assetModel, serviceAssetSchemaCollection, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     */
    AssignSchemaToAssetOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     */
    AssignSchemaToAssetOverlay.prototype.onSuccess = function () {
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     * @param error
     */
    AssignSchemaToAssetOverlay.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    AssignSchemaToAssetOverlay.defaultProps = {
        className: ''
    };
    AssignSchemaToAssetOverlay = __decorate([
        observer
    ], AssignSchemaToAssetOverlay);
    return AssignSchemaToAssetOverlay;
}(React.Component));
AssignSchemaToAssetOverlay.contextType = ApplicationContext;
export default injectIntl(AssignSchemaToAssetOverlay);
